<template>
  <div id="settings" class="wrrapper mb-1">
    <page-heading title="Pannel Settings" border>
      <template #content>
        <div class="flex align-center">
          <Input
            style="width: 20rem"
            v-model="searchQuery"
            placeholder="Search Panels"
            class="mb-base mr-2 mt-2"
          />
          <Select
            v-if="isAdmin"
            styles="mb-base mr-2 mt-2"
            :placeholder="branchPlaceHolder"
            :input="filterPanelByBranch"
            :options="brachData"
          />

          <Button
            :onClick="toggleAddPanelModal"
            className="button--primary add-user mr-2"
            title="Add panel setting"
          ></Button>
        </div>
      </template>
    </page-heading>
    <div class="settings-template">
      <data-table
        :cols="columns"
        :rows="pannelData"
        height="calc(100vh - 15rem)"
        :loading="loading"
      >
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu
            :rowData="actions"
            :handleItemClick="handleItems"
            :items="['Edit', 'Delete']"
          />
        </template>
      </data-table>
      <modal
        title="Add Pannel"
        name="addPanelSettingModal"
        class="custom-modal"
        height="auto"
        width="600"
        :adaptive="true"
      >
        <template v-slot:content>
          <div class="mt-1">
            <form @submit.prevent class="create-service mb-base">
              <Select
                styles="invoice-select"
                label="Panel"
                class="mb-2"
                :options="discountType"
                :input="handleDiscountTpye"
                :clearable="false"
                placeholder="Select"
              />
              <Select
                label="Select Servce"
                :disabled="panelInputs.service"
                styles="invoice-select"
                :input="handleServiceSelect"
                :options="servicesList"
                placeholder="Select"
                class="mb-2"
                :clearable="false"
              />
              <Input
                class="mb-base"
                label="Service Charges"
                :disabled="panelInputs.amount"
                v-model="registrationData.amount"
                @input="panelInputs.discount = false"
                type="number"
              />
              <Input
                class="mb-base"
                label="Discount Amount"
                v-model="registrationData.discount"
                @input="panelInputs.branch = false"
                :disabled="panelInputs.discount"
                type="number"
              />
              <Select
                class="mb-2 py-2"
                styles="expenses-select"
                label="Select branch"
                :input="handleBranchChangeCreatePanel"
                :placeholder="branchPlaceHolder"
                :disabled="panelInputs.branch"
                :clearable="false"
                :options="brachData"
              />
              <div class="flex justify-center pb-4">
                <Button
                  className="button--primary mr-2 custom-button"
                  title="Cancel"
                  :onClick="() => handleCancel('Create')"
                ></Button>
                <Button
                  className="button--primary custom-button"
                  title="Create Panel"
                  :loader="loading"
                  :onClick="handleCreatePanel"
                ></Button>
              </div>
            </form>
          </div>
        </template>
      </modal>
      <modal
        title="Edit Lookup"
        name="editmodal"
        class="custom-modal"
        height="auto"
        width="600"
        :adaptive="true"
      >
        <template v-slot:content>
          <div class="mt-1">
            <form @submit.prevent class="create-service mb-base">
              <Select
                label="Select Servce"
                styles="invoice-select"
                :input="handleServiceSelect"
                :options="servicesList"
                :placeholder="
                  singleLookUp &&
                    singleLookUp.service &&
                    singleLookUp.service.name
                "
                class="mb-2"
                :clearable="false"
              />
              <Select
                styles="invoice-select"
                label="Panel"
                class="mb-2"
                :options="discountType"
                :input="handleDiscountTpye"
                :clearable="false"
                :placeholder="singleLookUp && singleLookUp.lookup.name"
              />
              <Input
                class="mb-base"
                label="Service Charges"
                :placeholder="singleLookUp && singleLookUp.amount"
                v-model="registrationData.amount"
                type="number"
              />
              <Input
                class="mb-base"
                label="Discount Amount"
                v-model="registrationData.discount"
                type="number"
              />
              <Select
                class="mb-2 py-2"
                styles="expenses-select"
                label="Select branch"
                :input="handleBranchChangeCreatePanel"
                :clearable="false"
                :placeholder="
                  singleLookUp &&
                    singleLookUp.branch &&
                    singleLookUp.branch.name
                "
                :options="brachData"
              />
              <div class="flex justify-center">
                <Button
                  className="button--primary mr-2 custom-button"
                  title="Cancel"
                  :loader="loading"
                  :onClick="() => handleCancel('Edit')"
                ></Button>
                <Button
                  className="button--primary custom-button"
                  title="Udpate Panel"
                  :loader="loading"
                  :onClick="updatePanelSetting"
                ></Button>
              </div>
            </form>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Select from "@/components/Select.vue";
import Modal from "@/components/Modal";
import Input from "@/components/Input";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Button,
    DataTable,
    DropdownMenu,
    Select,
    Input,
    Modal
  },
  data() {
    return {
      id: "",
      isAdmin: false,
      brachData: [],
      panelInputs: {
        service: true,
        amount: true,
        discount: true,
        branch: true
      },
      selectedPanel: {},
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "name",
          label: "Name",
          sortable: true
          // link: true,
          // routerName: "BranchSetting",
        },

        {
          column: "panel_name",
          label: "Panel",
          sortable: true,
          sort: true
        },
        {
          column: "amount",
          label: "Service Charges",
          sortable: true,
          sort: true
        },
        {
          column: "discount",
          label: "Discount",
          sortable: true,
          sort: true
        },
        {
          column: "lookup_status",
          label: "Status",
          sortable: true,
          sort: true
        },
        {
          column: "branch_name",
          label: "branch",
          sortable: true,
          sort: true
        },
        { column: "action", label: "Actions" }
      ],
      registrationData: {
        // branchName: null,
        // branchAddress: null,
        // phoneNumber: null,
        // email: null,
        // logoUrl: null,
        // attachmentId: null,
      },
      searchQuery: ""
    };
  },
  methods: {
    ...mapActions("bussiness", [
      "addBussinessSettings",
      "updateSettings",
      "settingsList",
      "createBranch",
      "getAllLookUps",
      "editLookUp",
      "createLookUp",
      "deletePanelSetting",
      "updateLookup"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    ...mapActions("auth", ["uploadAttachment"]),
    ...mapActions("doctors", ["getDiscountList"]),
    ...mapActions("services", ["listServices"]),
    toggleAddPanelModal() {
      this.$modal.show("addPanelSettingModal");
      this.registrationData = {};
    },
    saveData() {
      const template = {
        header: this.$refs.header.editor.getContents(),
        footer: this.$refs.footer.editor.getContents(),
        note: this.$refs.note.editor.getContents()
      };
      if (this.settings.length > 0) {
        this.updateSettings({ id: this.id, payload: template }).then(() => {
          this.$toasted
            .success("Bussiness settings updated successfully")
            .goAway("3000");
        });
      } else {
        this.addBussinessSettings(template).then(() => {
          this.$toasted
            .success("Bussiness settings saved successfully")
            .goAway("3000");
        });
      }
    },
    handleCancel(data) {
      if (data === "Edit") {
        this.$modal.hide("editmodal");
      } else if (data === "Create") {
        this.$modal.hide("addPanelSettingModal");
      }
    },
    handleCreatePanel() {
      if (
        this.registrationData.lookupId &&
        this.registrationData.serviceId &&
        this.registrationData.branchId &&
        this.registrationData.amount
      ) {
        try {
          this.createLookUp({ payload: this.registrationData }).then(() => {
            this.$modal.hide("addPanelSettingModal");
            this.getAllLookUps({ id: this.user?.userBranchId });
          });
          this.panelInputs = {
            service: true,
            amount: true,
            discount: true,
            branch: true
          };
        } catch (error) {
          console.log(error);
        }
      } else {
        this.$toasted.error("Please check all feilds").goAway("3000");
      }
    },
    async handleItems(val, rowData) {
      this.registrationData = {};
      if (val === "Edit") {
        this.registrationData = {};
        this.id = rowData.id;
        await this.editLookUp({ id: rowData.id });
        this.registrationData.serviceId = this.singleLookUp?.serviceId;
        this.registrationData.lookupId = this.singleLookUp?.lookupId;
        this.registrationData.amount = this.singleLookUp?.amount;
        this.registrationData.branchId = this.singleLookUp?.branchId;
        this.registrationData.discount = this.singleLookUp?.discount;
        this.$modal.show("editmodal");
      } else if (val === "Delete") {
        await this.deletePanelSetting({ id: rowData?.id });
        this.getAllLookUps({ id: this.user?.userBranchId });
      }
    },
    handleDiscountTpye(val) {
      if (val && val !== null) {
        this.registrationData.lookupId = val.key;
        this.panelInputs.service = false;
        this.registrationData.branchId = this.fetchUserBranch?.find(
          e => this.user.userBranchId == e.id
        ).id;
      }
    },
    handleBranchChangeCreatePanel(val) {
      if (val && val !== null) {
        this.registrationData.branchId = val.key;
      }
    },
    handleBranchChange(val) {
      if (val && val !== null) {
        this.registrationData.branchId = val.key;
      }
    },
    handleServiceSelect(val) {
      if (val && val !== null) {
        this.registrationData.serviceId = val.id;
        this.panelInputs.amount = false;
      }
    },
    updatePanelSetting() {
      this.updateLookup({
        id: this.id,
        payload: this.registrationData
      });
      this.$modal.hide("editmodal");
      this.getAllLookUps({ id: this.user?.userBranchId });
    },
    filterPanelByBranch(val) {
      if (val && val !== null) {
        this.getAllLookUps({ id: val.key });
      }
    }
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings",
      lookUpSetting: "bussiness/lookUpSetting",
      singleLookUp: "bussiness/singleLookUp",
      loading: "loading",
      fetchUserBranch: "expenses/fetchUserBranch",
      attachmentId: "auth/attachmentId",
      attachmentUrl: "auth/attachmentUrl",
      discountList: "doctors/discountList",
      user: "auth/userInfo",
      listItems: "services/listItems"
    }),
    discountType() {
      const results = this.discountList?.map(obj => ({
        key: obj.id,
        name: obj?.name
      }));
      return results;
    },
    branchPlaceHolder() {
      const data = this.fetchUserBranch?.find(
        e => this.user.userBranchId == e.id
      );
      return data?.name;
    },
    servicesList() {
      const items = [];
      this.listItems &&
        this.listItems.map(item => {
          items.push({
            id: item.service.id,
            name: item.service?.name,
            lookup: item?.service?.lookup?.name,
            lookupId: item?.service?.lookup?.id,
            amount: item.amount,
            chargeId: item.id,
            serviceId: item.serviceId
          });
        });
      return items;
    },
    pannelData() {
      let pannelDto = [];
      this.lookUpSetting.length > 0
        ? this.lookUpSetting?.map(item => {
            if (
              item?.service?.name
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase()) ||
              item?.lookup?.name
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
            ) {
              pannelDto.push({
                name: item?.service?.name,
                amount: item?.amount,
                lookup_status: item?.status === 0 ? "Not Active" : "Active",
                id: item?.id,
                branch_name: item?.branch?.name,
                panel_name: item?.lookup?.name,
                discount: item?.discount
              });
            }
          })
        : [];
      return pannelDto;
    }
  },
  watch: {
    settings(val) {
      const ref = this.$refs || {};
      const item = val.find(item => item);
      if (item) {
        ref.header.editor.setContents(item.header, "api");
        ref.footer.editor.setContents(item.footer, "api");
        ref.note.editor.setContents(item.note, "api");
        this.id = item.id ? item.id : "";
      }
    }
  },
  async mounted() {
    await this.fetchBranch();
    this.getAllLookUps({ id: this.user?.userBranchId });
    await this.listServices();
    await this.getDiscountList();
    this.isAdmin = this.user.userRole.some(
      ({ name }) => name === "admin" || name === "doctor"
    );
    this.registrationData.branchId = this.fetchUserBranch?.find(
      e => this.user.userBranchId == e.id
    ).id;
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem?.name, key: elem.id });
    });
  }
};
</script>

<style>
#settings .settings-template {
  padding: 22px 65px 22px 65px;
}

#settings .save-template {
  padding: 13px 50px;
  margin-top: 65px;
}

.bussiness-header {
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 1.4;
  color: var(--ink-900);
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
</style>
